import {useEffect, useState} from 'react';
import packageJson from '../package.json';
global.appVersion = packageJson.version;

// version from response - first param, local version second param
const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g);

  // deepcode ignore FormatString: <please specify a reason of ignoring this>
  const versionsB = versionB.split(/\./g);

  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());
    const b = Number(versionsB.shift());

    if (a === b) {
      continue;
    }
    // deepcode ignore UseNumberIsNan: <please specify a reason of ignoring this>
    return a > b || isNaN(b);
  }
  return false;
};

const CacheBuster = ({children}) => {
  const [state, setState] = useState({
    loading: true,
    isLatestVersion: false,
  });

  useEffect(() => {
    fetch(`/meta.json?${new Date().getTime()}`, {cache: 'no-cache'})
      .then((response) => response.json())
      .then((meta) => {
        const latestVersion = meta.version;
        const currentVersion = global.appVersion;
        const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
        if (shouldForceRefresh) {
          console.log(`We have a new version - ${latestVersion}. Should force refresh`);
          setState({loading: false, isLatestVersion: false});
        } else {
          console.log(
                `You already have the latest version - ${latestVersion}. No cache refresh needed.`,
          );
          setState({loading: false, isLatestVersion: true});
        }
      })
      .catch((error) => {
        console.log('Something Went Wrong');
      });
  }, []);
  const {loading, isLatestVersion} = state;
  return children({loading, isLatestVersion});
};

export default CacheBuster;
